import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';


import './home.css';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import CustomPagination from '../../components/pagination/customPagination';


import Form from 'react-bootstrap/Form';




import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import PropertyCard from '../../components/property/propertyCard';

import { useNavigate, useParams, useLocation } from "react-router-dom";
import {connect} from 'react-redux';
import * as actions from '../../store/property/actions';
import * as locationActions from '../../store/location/actions';
import * as actionsPropertyType from '../../store/propertyType/actions';




const RentedProperties = ({getRentedProperties, rentedProperties, getPropertyTypes, propertyTypeWithAttributes, fetchLocations, suggestedLocation}) => {   
    let match = useParams("/:type/properties-for-rent/:propertyType"); 
    const selectedPropertyType = match.type.charAt(0).toUpperCase() + match.type.slice(1);
    const propertyTypeID = match.propertyType;
    const [ currentPage, setCurrentPage] = useState(1);
    const [ formData, setFormData ] = useState({
        title: '',
        location: '',
        property_type: selectedPropertyType,
        property_type_id: match.propertyType
    });
    const [propertyTypes, setPropertyTypes] = useState('');
    const [ propertyTypeSubCategory, setPropertyTypeSubCategory ] = useState('');
    const [inputValue, setInputValue] = useState('');
    const [ resultText, setResultText ] = useState('');
    const [ activeLocationId, setActiveLocationID ] = useState();

    // console.log('propertyTypes', propertyTypes)

    useEffect(() => {
		loadData();
	},[]);

    const loadData = async() => {
        let data = formData;
        data.is_rent = 1;
        data.page = 1;
        await getRentedProperties(data).then(res => {
            // console.log()
        })
        await getPropertyTypes().then(res => {
            // console.log()
        })
    }

    useEffect(() => {
        if(propertyTypeWithAttributes){
		    setPropertyTypes(propertyTypeWithAttributes);
            if(selectedPropertyType == 'Residential'){
                setPropertyTypeSubCategory(propertyTypeWithAttributes['residential_properties'])
            } else if(selectedPropertyType == 'Commercial'){
                setPropertyTypeSubCategory(propertyTypeWithAttributes['commercial_properties'])
            }
        }
	},[propertyTypeWithAttributes]);


    const findValueByAttributeCode = (attribute_code, attributes) => {
        const attributeObject = attributes.find(
            (attribute) => attribute.code === attribute_code
        );
        return attributeObject && attributeObject.value ? attributeObject.value : null;
    }

    

    const handlePageChange = (page) => {
        if (page >= 1 && page <= rentedProperties.pagination.total_pages) {
          setCurrentPage(page);
          let data = formData;
            data.page = page;
            data.is_rent = 1;
            getRentedProperties(data).then(res => {
                // console.log()
            });
        }
    };

    const updateInputValue = (value) => {
        setInputValue(value);
        setFormData({
            ...formData,
            location: value
        });
    }

    // When Click on Location and try to find out location
    const handleInputChange = (event) => {
        
        const { name, value } = event.target;
        setInputValue(value);
        setFormData({
            ...formData,
            [name]: value
        });
        
        // Fetch suggestions from the server when the input changes
        fetchLocations({searchTerm: value}).then(res => {
            if(value.length > 4 && res.payload.data && res.payload.data.length == 0){
                setResultText('No Results Found');
            } else {
                setResultText('');
            }
        });
    };


    // When Change Property type then change values of 
    const handlePropertyTypeChange = (event) => {
        const { name, value } = event.target;
        if(value == 'Residential'){
            setPropertyTypeSubCategory(propertyTypes['residential_properties'])
        } else if(value == 'Commercial'){
            setPropertyTypeSubCategory(propertyTypes['commercial_properties'])
        }
        setFormData({
            ...formData,
            [name]: value
        });
    }

    const handleChange = (event) => {
        
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value
        });
        
    };

    const handleSubmit = async (event) => { 
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        setCurrentPage(1);
        let data = formData;
        data.page = 1;
        data.is_rent = 1;
        getRentedProperties(data).then(res => {
            // console.log()
        });
    }
    
    // console.log('rentedProperties', rentedProperties)
    return (
        <div>
            <Header/>            

            <section className='pt-5 pb-5 bg-dark'>
                <Container>
                    <div className='card p-3 border-0'>
                        <Form onSubmit={handleSubmit}>
                            <Row>
                                <Col>
                                    <Form.Control placeholder="Keywords" name="title" onChange={handleChange} />
                                </Col>
                                <Col>
                                    <Form.Select aria-label="Propery Status" name="property_type" onChange={handlePropertyTypeChange} defaultValue={selectedPropertyType}>
                                        <option value="">Choose Property Type</option>
                                        <option value="Commercial">Commercial Property</option>
                                        <option value="Residential">Residential Property</option>
                                    </Form.Select>
                                </Col>
                                <Col>
                                    <Form.Select aria-label="Property Type" name="property_type_id" onChange={handleChange} defaultValue={propertyTypeID}>
                                        <option value="">Property Type</option>
                                        {
                                            propertyTypeSubCategory ?
                                                propertyTypeSubCategory.map((subcategory) => (
                                                <option key={`subcategory${subcategory.property_type_id}`} value={subcategory.property_type_id}>
                                                    {subcategory.title}
                                                </option>
                                                ))
                                            : ''
                                        }
                                    </Form.Select>
                                </Col>
                                <Col>
                                    <Form.Group as={Col}  controlId="formGroupLocation">
                                        {/* <Form.Label>Location</Form.Label> */}
                                        <Form.Control type="text" placeholder="Location" name="location" 
                                            value={inputValue} 
                                            onChange={handleInputChange} 
                                            className={ "mb-3"}
                                        />
                                    </Form.Group>
                                    { 
                                        suggestedLocation && suggestedLocation.length > 0 ?
                                            <div className="autocomplete-result">
                                                <ul>
                                                {
                                                    suggestedLocation.map((location, index) => {
                                                        return <li key={`top30Trendingside${index}`} className={activeLocationId == location.location_id ? 'active' : ''} onClick={() => setActiveLocationID(location.location_id)}>
                                                                    
                                                                    <div className="content">
                                                                        <div>
                                                                            <div className="track-name">
                                                                                <div className="text-2" dangerouslySetInnerHTML={{__html: location.location_name}} onClick={() => updateInputValue(location.location_name)}></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                            </li>
                                                    })
                                                    
                                                }
                                                </ul>
                                            </div>
                                        : ''
                                    }
                                </Col>
                                <Col xs={1}>
                                    <Button type="submit" variant="primary">Search</Button>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </Container>
            </section>
            { 
            rentedProperties && rentedProperties.properties && rentedProperties.properties.length > 0 ?
            <section className='pt-5 pb-5'>
                <Container>
                    { rentedProperties && rentedProperties.pagination && rentedProperties.pagination.totalRecords ?<h5 className="mb-4"> {rentedProperties.pagination.totalRecords } Results</h5> : ''}
                    <Row>
                    { 
                        rentedProperties.properties.map((property, propertyIndex) => {
                            return <Col xs={4} key={`property${propertyIndex}${property.entity_id}`}>
                                        <PropertyCard item={property} />
                                    </Col>
                        })
                    }                        
                    </Row>
                    <div className="justify-content-center d-flex">
                    {
                        rentedProperties.pagination
                            ? 
                            <CustomPagination 
                                totalPages={rentedProperties.pagination.total_pages} 
                                currentPage={rentedProperties.pagination.page} 
                                onPageChange={handlePageChange} 
                            />
                        : ''
                    }
                    </div>
                </Container>
            </section>
            : ''
            }
            <Footer/>
        </div>
    )
}
function mapStateToProps(state) {
    return {
        rentedProperties: state.property.rentedProperties,
        suggestedLocation: state.location.suggestedLocation,
        propertyTypeWithAttributes: state.propertyType.propertyTypeWithAttributes
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
        getPropertyTypes: () => dispatch(actionsPropertyType.getPropertyTypes()),
        fetchLocations: (post) => dispatch(locationActions.getAutocompleteLocation(post)),
        getRentedProperties: (post) => dispatch(actions.getRentedProperties(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(RentedProperties);